import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { actions } from './redux';
var isGAIDExist = typeof process.env.GA_ID === 'string' && process.env.GA_ID.length > 0;
var trackPage = function trackPage(store, url) {
  var enabled = store.getState().tracking.enabled;
  if (!enabled || !isGAIDExist) {
    return;
  }
  window.gtag('config', process.env.GA_ID, {
    page_path: url
  });
  if (process.env.GW_ID) {
    window.gtag('config', process.env.GW_ID, {
      page_path: url
    });
  }
};
var trackEvent = function trackEvent(store, payload) {
  var enabled = store.getState().tracking.enabled;
  if (!enabled || !isGAIDExist) {
    return;
  }
  var event_category = payload.category,
    action = payload.action,
    event_label = payload.label,
    value = payload.value;

  // Send event
  window.gtag('event', action, {
    event_category: event_category,
    event_label: event_label,
    value: value
  });
};
var TrackingMiddleware = function TrackingMiddleware(store) {
  return function (next) {
    return function (action) {
      var actionMap = _defineProperty(_defineProperty({}, actions.trackPage, trackPage), actions.trackEvent, trackEvent);
      if (actionMap[action.type] !== undefined) {
        actionMap[action.type](store, action.payload);
      }
      next(action);
    };
  };
};
export default TrackingMiddleware;